import { render } from "./ExitModal.vue?vue&type=template&id=f5c90126"
import script from "./ExitModal.vue?vue&type=script&lang=js"
export * from "./ExitModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__